module.exports = __webpack_public_path__ + "static/media/person7.ad178aeb.svg";